module.exports = __webpack_public_path__ + "static/media/work1.8ee527bd.jpg";